import { render } from "./LandingLayout.vue?vue&type=template&id=3f865996&scoped=true"
import script from "./LandingLayout.vue?vue&type=script&lang=js"
export * from "./LandingLayout.vue?vue&type=script&lang=js"

import "./LandingLayout.vue?vue&type=style&index=0&id=3f865996&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f865996"]])

export default __exports__